import { render, staticRenderFns } from "./ServeSale202301Step3.vue?vue&type=template&id=652c61fe&scoped=true"
import script from "./ServeSale202301Step3.vue?vue&type=script&lang=js"
export * from "./ServeSale202301Step3.vue?vue&type=script&lang=js"
import style0 from "./ServeSale202301Step3.vue?vue&type=style&index=0&id=652c61fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652c61fe",
  null
  
)

export default component.exports